export const NAME = 'ADDRESS'

export const ADDRESS = `${NAME}/ADDRESS`;

export const saveAddress = data => ({
    type: ADDRESS,
    data
});